import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/Tags.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "order-detail",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('view-box', {
    ref: "viewBox"
  }, [_c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "title font-size-h3-large"
  }, [_c('div', {}, [_vm._v(i18n.tc("418"))])]), _c('div', {
    staticClass: "state",
    style: {
      color: _vm.getEventFilterState(_vm.eventMap).color
    }
  }, [_vm._v(" " + _vm._s(_vm.getEventFilterState(_vm.eventMap).name) + " ")])]), _c('div', {
    staticClass: "customer font-size-h3-normal"
  }, [_c('div', {
    staticClass: "customer-line"
  }, [_c('div', {
    staticClass: "customer-label"
  }, [_c('span', {
    staticStyle: {
      "width": "4rem"
    }
  }, [_vm._v(i18n.tc("419"))]), _vm._v(" ： ")]), _c('div', {
    staticClass: "customer-value"
  }, [_vm._v(_vm._s(_vm.eventMap.event_no))])]), _c('div', {
    staticClass: "customer-line"
  }, [_c('div', {
    staticClass: "customer-label"
  }, [_c('span', {
    staticStyle: {
      "width": "4rem"
    }
  }, [_vm._v(i18n.tc("155"))]), _vm._v(" ： ")]), _c('div', {
    staticClass: "customer-value"
  }, [_vm._v(_vm._s(_vm.eventMap.custom_name || ''))])]), _vm.eventProduct.pname ? _c('div', {
    staticClass: "customer-line"
  }, [_c('div', {
    staticClass: "customer-label"
  }, [_c('span', {
    staticStyle: {
      "width": "4rem"
    }
  }, [_vm._v(i18n.tc("416"))]), _vm._v(" ： ")]), _c('div', {
    staticClass: "customer-value"
  }, [_vm._v(_vm._s(_vm.eventProduct.pname))])]) : _vm._e(), _c('div', {
    staticClass: "customer-line"
  }, [_c('div', {
    staticClass: "customer-label-link"
  }, [_c('span', {
    staticStyle: {
      "width": "4rem",
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('span', [_vm._v(i18n.tc("413"))]), _c('span', [_vm._v(i18n.tc("414"))]), _c('span', [_vm._v(i18n.tc("415"))])]), _vm._v(" ： ")]), _c('div', {
    staticClass: "customer-value"
  }, [_vm._v(_vm._s(_vm.eventMap.custom_linkperson))])]), _c('div', {
    staticClass: "customer-line"
  }, [_c('div', {
    staticClass: "customer-label"
  }, [_c('span', {
    staticStyle: {
      "width": "4rem"
    }
  }, [_vm._v(i18n.tc("157"))]), _vm._v(" ： ")]), _c('div', {
    staticClass: "customer-value"
  }, [_vm._v(_vm._s(_vm.eventMap.custom_phone))])]), _c('div', {
    staticClass: "customer-line"
  }, [_c('div', {
    staticClass: "customer-label"
  }, [_c('span', {
    staticStyle: {
      "width": "4rem"
    }
  }, [_vm._v(i18n.tc("242"))]), _vm._v(" ： ")]), _c('div', {
    staticClass: "customer-value"
  }, [_c('span', [_vm._v(_vm._s(_vm.eventMap.gps_addr + _vm.eventMap.custom_detail_addr))])])]), _c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "tag-line",
    class: {
      'tag-line-close': !_vm.tagLineShow
    }
  }, [_c(__unplugin_components_0, {
    attrs: {
      "list": _vm.taglist
    }
  })], 1)])])]), _c('div', {
    staticClass: "tabs"
  }, [_c('Tab', {
    staticClass: "tab-effect",
    attrs: {
      "default-color": "#1a1e24",
      "active-color": "#3ccba6",
      "bar-active-color": "#3ccba6",
      "custom-bar-width": "15px",
      "line-width": 2
    },
    model: {
      value: _vm.tabsIndex,
      callback: function ($$v) {
        _vm.tabsIndex = $$v;
      },
      expression: "tabsIndex"
    }
  }, _vm._l(_vm.tabs, function (item, index) {
    return _c('TabItem', {
      key: index
    }, [_vm._v(_vm._s(item))]);
  }), 1), _c('Swiper', {
    staticClass: "swiper",
    attrs: {
      "show-dots": false,
      "threshold": 100,
      "height": "100%"
    },
    model: {
      value: _vm.tabsIndex,
      callback: function ($$v) {
        _vm.tabsIndex = $$v;
      },
      expression: "tabsIndex"
    }
  }, [_c('SwiperItem', [_c('div', {
    staticClass: "c-process-tetail info-footer"
  }, [_c('flow', [_vm._l(_vm.stateList, function (item, index) {
    return [_c('flow-state', {
      attrs: {
        "state": item.value,
        "title": item.name,
        "is-done": item.stateDone
      }
    }), !item.lineLimit ? _c('flow-line', {
      attrs: {
        "is-done": item.lineDone,
        "process-span": item.process
      }
    }) : _vm._e()];
  })], 2)], 1), _c('pageInfo', {
    attrs: {
      "eventTmpl": _vm.eventTmpl,
      "eventInfo": _vm.eventMap,
      "eventExtFields": _vm.otherFiledValueList,
      "serviceList": _vm.serviceList
    }
  })], 1), _vm.isOrderMessage ? _c('SwiperItem', [_c('OrderMessage', {
    ref: "orderMessage",
    attrs: {
      "eventId": _vm.eventId
    }
  })], 1) : _vm._e(), _vm.isCustomerEvaluate ? _c('SwiperItem', [_c('CustomerEvaluate', {
    ref: "customerEvaluate",
    attrs: {
      "eventId": _vm.eventId,
      "eventState": _vm.eventState
    }
  })], 1) : _vm._e(), _vm._l(_vm.detailCtrlList, function (item) {
    return [_c('SwiperItem', {
      key: item.sntid
    }, [_c('DetailCtrlList', {
      attrs: {
        "id": item.serviceNodeTmplId,
        "eventId": _vm.eventId,
        "config": item
      }
    })], 1)];
  })], 2)], 1)]), _c('EventBottomOptions', {
    ref: "orderBottomOptions",
    attrs: {
      "eventId": _vm.eventId,
      "eventMap": _vm.eventMap,
      "eventState": _vm.eventState
    },
    on: {
      "on-success": _vm.onSuccessBottomBtn,
      "on-maketag": function ($event) {
        _vm.taglist = $event;
      }
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };